/**
 * Csvアップロード バリデーションルール
 */
export default {
  csv: 'required|ext:csv|size:5000',
}
